module.exports = __webpack_public_path__ + "img/a4ec16c.png";